import { render, staticRenderFns } from "./ModalTambahPenerima.vue?vue&type=template&id=6bf35b90&"
import script from "./ModalTambahPenerima.vue?vue&type=script&lang=js&"
export * from "./ModalTambahPenerima.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports